<header>
  <button (click)="toggleSideNav()" class="toggle-sidebar"><mat-icon>menu</mat-icon></button>

  <!-- <div class="search" [formGroup]="form">
    <search formControlName="search"></search>
  </div> -->

  <div class="end-content" [formGroup]="form">
    <app-notifications-button></app-notifications-button>
    <button class="header-icon" #languagesButton="matMenuTrigger" [matMenuTriggerFor]="languagesMenu">
      <app-svg-icon [icon]="IconsConstants.GLOBAL_ICON"></app-svg-icon>
    </button>
    <!-- start profile options -->
    <!-- <div class="apps-dropdown" *ngIf="appTypes?.length > 1 && userProfileIcon">
        <app-custom-dropdown 
          [dropdownConfigurations]="userProfileDropDownConfigs" 
          [list]="appTypes" 
          [enableSearch]="false"
          [iconTemplate]="application_icons"
          [optionCustomTemplate]="profiles"
          (selectionChange)="onSelectionChange($event)">
        </app-custom-dropdown>
      </div> -->
    <!-- end profile options -->
  </div>
</header>

<mat-menu #languagesMenu>
  <ng-container *ngFor="let item of languageMenuItems">
    <button
      mat-menu-item
      class="menu-item"
      (click)="checkCurrentLanguageAndChangeIt(item.language)"
      [ngClass]="item.language === language ? 'current-lang' : ''"
    >
      <span>{{'Lang.'+item.language| translate}}</span>
    </button>
  </ng-container>
</mat-menu>

<ng-template #profiles let-option="option">
  <div class="user-profile-icons">
    <span class="icon"><img [src]="option.dropDownValue?.icon?.icon" /></span>
    <span>{{option?.dropDownDisplayName}}</span>
  </div>
</ng-template>

<ng-template #application_icons>
  <img [src]="userProfileIcon?.icon" />
</ng-template>
